import React from 'react';
import { Col, Form } from 'antd';

import { useApplicationContext } from '@/context/v1/Application/context';
import { LineSelect } from '@/components/ui/Inputs/LineSelect';
import { useLines } from '@/hooks/v1';
import FormItem from '@/components/ui/FormItem';

const { useFormInstance, useWatch } = Form;

interface LinesProps {
	disabled?: boolean;
}

export function Lines({ disabled = false }: Readonly<LinesProps>): JSX.Element {
	const form = useFormInstance();
	const { company, organization } = useApplicationContext();

	const lineId = useWatch('line_id', form);
	const sectorId = useWatch('sector_id', form);

	const {
		data: lines,
		isLoading,
		isFetching,
		isError
	} = useLines({ organization_id: organization?.id, company_id: company?.id, sector_id: sectorId });

	function handleSelectLine(id: string) {
		form.setFieldValue(['line_id'], id);
		form.setFieldValue(['workstation_id'], undefined);
	}

	function handleClearLines() {
		form.setFieldValue(['line_id'], undefined);
		form.setFieldValue(['workstation_id'], undefined);
	}

	return (
		<Col xs={24} sm={12}>
			<FormItem
				name={['line_id']}
				label="Line"
				labelCol={{ span: 24 }}
				requiredMessage="Select the line"
				required
			>
				<LineSelect
					size="large"
					lines={lines}
					lineId={lineId}
					fieldName="line_id"
					sectorId={sectorId}
					loading={isFetching}
					handleSelectLine={handleSelectLine}
					handleClearLines={handleClearLines}
					disabled={disabled || isLoading || isFetching || isError || !sectorId}
				/>
			</FormItem>
		</Col>
	);
}
